import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

import Head from "../Head/Head";
import NavBar from "../NavBar/NavBar";
import ContactUs from "../Forms/ContactUs/ContactUs";
import Footer from "../Footer/Footer";
import Prefer from "../Prefer/Prefer";
import Offices from "../Offices/Offices";
import InstantQuote from "../InstantQuote/InstantQuote";

import HeroImg from "../../images/template-hero.png";
import HeroBanner from "../../images/template-hero.jpg";

import LanguagesContents from "../../data/languages";

import "./LanguageTemplate.css";

const LanguageTemplate = ({ language }) => {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const type = language.type
    .split(" ")
    .map((lang) => lang.charAt(0).toUpperCase() + lang.slice(1))
    .join(" ");

  useEffect(() => {
    const checkLanguage = (lang) => {
      return lang.name.toLowerCase() === type.toLowerCase();
    };
    if (LanguagesContents.find(checkLanguage)) setOpen(true);
    else history.replace("/404");
  }, [history, type]);

  return (
    <>
      {open && (
        <div className="template position-relative">
          <Head
            title={`${type} interpretation services in near you | certified ${type} interpreters in near you`}
            description={`Get ${type} interpretation services in near you with top certified ${type} interpreters in near you. We offer ${type} interpretation services in near you in over 250 languages.`}
            keywords={`translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous interpretation services, multilingual services, sworn translators, certified translations, ${type}`}
          />
          <NavBar />
          <div className="template__hero container overflow-hidden d-flex f-50 align-center justify-between position-relative z-1">
            <div className="f-50 my-40">
              <div className="d-flex flex-column align-start justify-center">
                <h2 className="font-heading text-capitalise">
                  Professional {type} interpretation at Your Finger Tips
                </h2>
                <p className="font-bigger mt-40">
                  We provide {type} interpretation at the most professional
                  level bearing client specifics and interest at the core of our
                  services.
                </p>
                <a
                  href="/quote"
                  className="template__link mt-40 py-10 px-20 font-bold"
                >
                  REQUEST A QUOTE
                </a>
              </div>
            </div>
            <div className="d-flex flex-row-reverse justify-end overflow-hidden f-50">
              <img className="d-flex" src={HeroImg} alt="" />
            </div>
          </div>
          <img className="template__banner my-20" src={HeroBanner} alt="" />
          <div className="template__sec1 container d-flex flex-column align-center justify-between">
            <div className="">
              <h2 className="font-heading">{type} Interpretation Services</h2>
              <p className="my-40 lh-lg font-heavy">
                Oneconverse is a {type} interpretation services provider with
                top {type} language interpreters. They offer a wide range of
                services from the standard interpretation to the interpretation
                of medical terms.In today's workplace, it is hard to find
                appropriate interpreters for certain meetings and conferences
                due to the limited number of staff available and their busy
                schedules.{" "}
              </p>
              <p className="my-40 lh-lg font-heavy">
                Oneconverse is a company with a difference. We specialize in
                providing professional {type} interpretation services to
                companies, law firms, and governments.Oneconverse is a leading
                {type} interpreting company in the US. They offer professional
                {type} translation and interpretation services in over 100
                languages and deliver them across various sectors like
                government, healthcare, education and hospitality.Oneconverse is
                a professional {type} translation and interpretation company
                that has delivered its services to more than 250 countries
                across different sectors like healthcare, education,government
                and hospitality. They offer professional {type} translation
                services in over 200 languagesand deliver them across various
                sectors like government, healthcare, education and hospitality
                {type} Interpretation services are provided by companies that
                have the expertise to understand the nuances of language.
                Oneconverse's highly-skilled {type} interpreters that can help
                you translate your content into any other language for an
                accurate understanding of what your audience needs to know about
                your products or services.
              </p>
              <p className="my-40 lh-lg font-heavy">
                Oneconverse provides a range of {type} interpretation services
                with top {type} Language interpreters.{type} Interpretation
                services by Oneconverse are available in over 300 Cities
                throughout the world. They provide high quality professional,
                reliable and affordable {type} interpretation services{" "}
              </p>
              <a
                href="/quote"
                className="template__link my-40 py-10 px-20 font-bold"
              >
                REQUEST A QUOTE
              </a>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Professional {type} interpretation services
                </h2>
                <p className="lh-lg font-heavy">
                  Oneconverse is a professional interpreting agency that is
                  dedicated to providing accurate, timely and effective {type}
                  interpretation services.The company has more than 2000
                  qualified native {type} interpreters who provide professional
                  language translation across the globe. With these services,
                  businesses can work more smoothly with their {type}-speaking
                  counterparts.
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse is proud of its ability to offer professional
                  {type} interpretation services that are affordable and
                  reliable. These services help businesses grow their
                  international markets by opening up new opportunities for them
                  to communicate with their {type}-speaking
                  counterparts.Oneconverse, a {type} Interpretation services
                  with top-tier {type} interpreters, provides professional
                  interpretation services to businesses and individuals.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  With Oneconverse's interpretive services, companies can
                  understand their clients more easily and effortlessly.
                </h2>
                <p className="lh-lg font-heavy">
                  Oneconverse is a professional {type} interpretation services
                  with top-class interpreters. With these interpreters, you can
                  get your documents and conversations translated to and from
                  {type}.Oneconverse is dedicated to providing high-quality
                  services for its customers. They offer scheduled appointments,
                  one-on-one interpretation, and deliveries of translations on
                  the same day!Oneconverse offers 24/7 availability as well as a
                  range of payment options such as pay per minute or hour.
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse is a service that provides professional {type}
                  interpretation services to businesses and organizations. They
                  make it easy for clients to get in touch with top-tier {type}
                  language interpreters from all over the world.Oneconverse
                  helps its clients make international connections by providing
                  a platform where you can find a qualified interpreter within
                  24 hours.
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Why you need our {type} Interpretation services at Oneconverse
                </h2>
                <p className="lh-lg font-heavy">
                  {type} as a foreign language is not as easy as it may seem. It
                  can be challenging for those who do not speak the language
                  fluently and for those who want to include {type} in their own
                  business. But we at Oneconverse offers you a {type}
                  interpretation service that is both affordable and reliable.
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse provides high quality {type} interpretation
                  services in multiple languages such as Spanish, Chinese, and
                  Arabic. Our interpreters are native speakers with years of
                  experience in the industry. We offer fast turnaround times and
                  bilingual customer support services for our customers all over
                  the world including France, Spain, China, and America.
                </p>
                <p className="lh-lg font-heavy">
                  A wide variety of reasons may require you to use our {type}
                  interpretation services. The most common one is that you want
                  to understand what your audience would be saying. This can be
                  done through verbal or written means. You may also need it for
                  an interview, live conference call, or a formal
                  presentationThis is where we come in – we offer a {type}
                  Interpretation service at Oneconverse that can help you
                  understand your audience better and deliver better results as
                  well as engaging conversations with them.
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse always takes an approach to provide the best
                  customer care to its clients. For this reason, they have
                  partnered with a {type} interpreter service to make sure that
                  they are providing an excellent experience.Our {type}
                  interpretation services are not just about translation. They
                  also address customer care issues that require more than just
                  translation. This includes any kind of professional or
                  personal contact with Oneconverse’s team members.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Affordable {type} Interpretation Services for Your Business .
                  With 5000 {type} interpreters from 250 countries
                </h2>
                <p className="lh-lg font-heavy">
                  Oneconverse provides affordable interpretation services for
                  your business. As one of the largest global {type}
                  interpreting companies, Oneconverse can provide you with a
                  wide variety of language and cultural expertise.
                </p>
                <p className="lh-lg font-heavy">
                  {type} interpreters are diverse and come from 250 countries.
                  They speak Spanish, English, Chinese, German and more than 50
                  other languages. Oneconverse is able to provide this level of
                  diversity because they have 5000 {type} interpreters in their
                  database from all over the world.
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse offers a variety of services at different levels
                  in order to cater for all kinds of businesses - from startups
                  to Fortune 500 companies in France and worldwide in over 50
                  languages.
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Oneconverse provides affordable interpretation services that
                  can help you easily communicate with your customers and
                  employees.
                </h2>
                <p className="lh-lg font-heavy">
                  Oneconverse has been providing translation and interpretation
                  services since 2006. It is a one-stop shop for businesses to
                  find the right interpreters at a fraction of the cost. With
                  5000 {type} interpreters from 250 countries, Oneconverse is
                  your one-stop shop for all languages.In this section, we will
                  learn about Oneconverse's background and how it works as a
                  translation company. We will also learn about its features and
                  what it provides to its customers
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse, a {type} interpretation service, provides 5000
                  interpreters from 250 countries. It helps companies to save
                  time and money that they otherwise would have spent on
                  translators.Oneconverse provides affordable and professional
                  {type} interpretation services for your business. With 5000
                  interpreters from 250 countries, Oneconverse lets you connect
                  with customers and clients worldwide through smooth
                  translations.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse is an affordable {type} interpretation service
                  that helps businesses to build bridges between cultures. It
                  also offers translation services to help businesses succeed in
                  their international business endeavors.Interpretation services
                  are essential for business communication. They help people who
                  come from different countries to understand each other's
                  language, culture, and customs. Without these, the success of
                  any company would be very difficult to achieve because it can
                  lead to communication issues.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Why Choose Our {type} Interpretation services?
                </h2>
                <p className="lh-lg font-heavy">
                  With the rise of technology and globalization, the need for a
                  foreign language interpretation service has become a
                  necessity. We provide quality, confidentiality,
                  cost-effectiveness, transparency, and timely execution of our
                  {type} interpretation services.We have integrated cutting-edge
                  technology to help make sure that our clients get what they
                  want from their {type} interpretation services. Our company
                  offers a variety of services such as translation interpreting,
                  transcription interpreting for conferences and meetings.
                </p>
                <p className="lh-lg font-heavy">
                  The translation service company, Oneconverse, offers a
                  reliable and effective {type} Interpretation service. The
                  company provides quality {type} interpretation services from
                  English to {type} at a cost-effective price. The company also
                  guarantees confidentiality and timely execution of our {type}
                  Interpretation services.We offer {type} interpretation service
                  that is confidential and produces a high-quality result in a
                  timely manner while maintaining the highest level of accuracy.
                </p>
                <ul className="lh-lg font-heavy ml-20">
                  <li> Quality assurance</li>
                  <li> Multi-layered approach for each project</li>
                  <li> Full-service interpretation</li>
                  <li> Quality control is a priority</li>
                  <li> 100% accuracy</li>
                  <li> Full satisfaction with no risk</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Benefits of Outsourcing {type} Interpretation Services To
                  Oneconverse
                </h2>
                <p className="lh-lg font-heavy">
                  The process of {type} interpretation is quite expensive.
                  However, the benefits of outsourcing {type} Interpretation
                  services to Oneconverse are quite evident. They can provide
                  high-quality {type} at a cheaper price.Outsourcing is widely
                  used in numerous industries, and it includes professional
                  services as well as manufacturing. People can easily find
                  plenty of examples where they can see how it has helped
                  companies save money on hiring human translators.
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse offers {type} interpretation services for an
                  affordable price without compromising on quality or accuracy.
                  Having a oneconverse interpreting service will help you reduce
                  the risk of errors in your translated content
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Outsourcing {type} interpretation services is the best way to
                  save time, money, and risk.
                </h2>
                <p className="lh-lg font-heavy">
                  The benefits of outsourcing are many when you consider how
                  much time it takes to build a relationship with an
                  interpreter. So if you are looking for someone who can speak
                  {type} in your office or in-house meeting, then it’s best that
                  you outsource this service.Outsourcing your {type}
                  interpretation needs not just saves time but also gives you
                  more flexibility in terms of interpreting language
                  requirements.
                </p>
                <p className="lh-lg font-heavy">
                  The benefits of outsourcing {type} interpretation services to
                  Oneconverse is that they can provide a wide variety of
                  linguistic services in multiple languages. They understand the
                  needs and requirements of their customers and exceed their
                  expectations when it comes to quality, efficiency, and
                  cost.Oneconverse provides a wide range of linguistic services
                  in multiple languages. They can provide {type} interpretation
                  services in more than 250 languages Oneconverse has been able
                  to provide quality, efficient, and cost effective {type}
                  interpretation services for businesses large and small since
                  2009.
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Types of {type} Interpretation Services
                </h2>
                <h2 className="font-heading py-40">
                  Consecutive {type} Interpretation services
                </h2>
                <p className="lh-lg font-heavy">
                  Oneconverse’s consecutive {type} interpretation service is
                  quite popular in the market. It allows companies to provide
                  their customers with multiple languages for direct
                  communication.Oneconverse’s consecutive {type} interpretation
                  service provides 250 languages support, which is constantly
                  growing by adding new ones. The company provides an
                  easy-to-use interface with instant translations and other
                  features that make the process easier for the customer.
                </p>
                <p className="lh-lg font-heavy">
                  We are an accredited agency that offers 250 languages for
                  Consecutive {type} interpretation services. We provide our
                  customers with high quality interpretations at the lowest
                  rates in the market.Consecutive {type} interpretation is a
                  process where certified {type} interpreters, who are also
                  native speakers of the language they are interpreting into,
                  translate into or out of {type} during a call. Our
                  interpreters are skilled in multiple languages with over 15
                  years of experience combined in the industry.
                </p>
                <p className="lh-lg font-heavy">
                  We offer consecutive {type} interpretation services for {type}
                  to 250 different languages with our dedicated customer service
                  team. Our interpreters offer an array of professional
                  skillsets and backgrounds including law, medicine, teaching
                  and economics. We provide {type} interpretation services in
                  over 250 languages for many countries, including the United
                  States, Canada, France, Belgium, Saudi Arabia and UAE.
                </p>
                <p className="lh-lg font-heavy">
                  {type} Interpretation is a service that has been provided to
                  governments and individuals for decades. Our clients have come
                  from different industries such as international trade,
                  academia, healthcare and more.
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  {type} Simultaneous Interpretation services
                </h2>
                <p className="lh-lg font-heavy">
                  The Oneconverse {type} Interpretation Services is one of the
                  most prestigious {type} simultaneous interpretation services
                  in the world. Our highly qualified team of professional {type}
                  simultaneous interpreters interpret live interaction between
                  two parties in any language to {type}.{type} simultaneous
                  interpretation is made possible by combining our simultaneous
                  interpretation equipments with our professional {type}
                  interpreters.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  The Oneconverse {type} simultaneous interpretation service is
                  the only service that offers simultaneous {type}
                  interpretation service in 250 languages.This service is great
                  for large conferences where people come from all over the
                  world and for international phone calls. We provide {type}
                  interpretation services in real time so there is no delay in
                  communication which makes it easier to hold a conversation.
                  {type} simultaneous interpretation services are growing more
                  and more popular every year because of the convenience they
                  offer to their users. The language barrier has never been an
                  issue thanks to this service which can be used anywhere and
                  anytime.
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Our {type} simultaneous interpretation services are for all
                  types of conferences and meetings. We provide translation and
                  interpretation services in 250 languages.
                </h2>
                <p className="lh-lg font-heavy">
                  What is our simultaneous {type} interpretation service?
                </p>
                <p className="lh-lg font-heavy">
                  Our team of professional and bilingual interpreters and
                  translators provides simultaneous {type} interpretation to any
                  type of meeting or conference, including:
                </p>
                <ul className="lh-lg font-heavy ml-20">
                  <li>Business meetings</li>
                  <li>Marketing presentations</li>
                  <li>Training sessions</li>
                  <li>Social events</li>
                  <li>Cultural events</li>
                </ul>
                <p className="lh-lg font-heavy">
                  When it comes to {type} interpretation services, we provide
                  consecutive interpreting in 250 languages.Our goal is to make
                  sure that our clients are satisfied with the quality of our
                  services and the professional attitude of our interpreters. We
                  achieve this by providing highly qualified, highly skilled
                  interpreters with fast turnaround time, confidentiality and
                  professionalism.
                </p>
              </div>
            </div>
          </div>
          <Prefer />
          <Offices />
          <ContactUs />
          <div className="container">
            <InstantQuote />
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

export default LanguageTemplate;
